import { Box, Typography } from "@mui/material";

const FiltrosSecao = ({ titulo, descricao, gap = 2, children }) => (
  <Box>
    {titulo && (
      <Typography variant="body2" sx={{ fontWeight: 700, color: "#334155" }}>
        {titulo}
      </Typography>
    )}
    <Box display="flex" flexDirection="column" gap={gap} sx={{ mt: 1.5 }}>
      {children}
    </Box>
    {descricao && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
        {descricao}
      </Typography>
    )}
  </Box>
);

export default FiltrosSecao;
